import React from 'react'

import Check from '@images/check_icon.svg'

export default (props) =>
  <img {...props} src={Check}></img>